import { ChevronLeft } from "lucide-react";
import { FC } from "react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";

import { CMSSaveButton } from "./cms-save-button";

type Props = {
  skuId: string;
  skuName: string;
};

export const CMSHeader: FC<Props> = ({ skuId, skuName }) => (
  <div className="flex items-center border-b p-4">
    <div className="flex-1">
      <Button variant="outline" asChild>
        <Link to={`/skus/${skuId}/webpage`}>
          <ChevronLeft /> Back to SKU
        </Link>
      </Button>
    </div>
    <div className="flex-1">
      <p className="text-md font-medium text-center">
        Edit Webpage - SKU {skuId} - {skuName}
      </p>
    </div>
    <div className="flex-1 flex justify-end">
      <CMSSaveButton />
    </div>
  </div>
);
